/// <reference path="../../../app.definition.ts" />

import { Util } from "@common/util";
import angular from "angular";
    class EcvFooter {
        static $inject = ["$scope"];

        constructor(
            private $scope:ng.IScope
        ) {
            let footerVm: any = this;
            footerVm.newTabMsg = Util.OPN_NEW_TAB_MSG;
            $(window).blur(function () {
                $scope.$apply(function () {
                    footerVm.isOpen = false;
                })
            })
        }

    }

    function ecvFooter(): ng.IDirective {
        return {
            restrict: 'E',
            templateUrl: 'app/common/directive/footer/templates/footer.directive.html',
            replace: true,
            scope:true,
            controller: EcvFooter,
            controllerAs: 'footerVm',
            bindToController: {
                'isOpen': '='
            },
            link: (scope: ng.IScope, element: ng.IAugmentedJQuery): void => {}
        }
    }

    angular.module('eCareVault.common.directives').directive('ecvFooter', ecvFooter);
